import { isNumber } from 'lodash-es';

import {
  HoneycombTileData,
  HoneycombTileNumericData,
} from '../types/honeycomb.js';

export const isHoneycombTileNumericData = (
  data: HoneycombTileData,
): data is HoneycombTileNumericData => isNumber(data.value);
